const ThumbnailSize = {
  OverXl: 388,
  OverMd: 250,
  OverSm: 286,
  Default: 188,
};

export default ThumbnailSize;
